<template>
  <div class="mobile-confirm-overlay" v-if="visible" @click="handleOverlayClick">
    <div class="mobile-confirm-content" @click.stop>
      <div class="modal-title">{{ title }}</div>
      <div class="modal-message">{{ message }}</div>
      <div class="modal-actions">
        <button class="modal-btn modal-btn-cancel" @click="handleCancel">{{ cancelButtonText }}</button>
        <button class="modal-btn modal-btn-confirm" @click="handleConfirm">{{ confirmButtonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileConfirm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '提示'
    },
    message: {
      type: String,
      default: ''
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    }
  },
  methods: {
    handleOverlayClick() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    handleCancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="less">
.mobile-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

.mobile-confirm-content {
  width: 280px;
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  animation: slideUp 0.2s ease;
}

.modal-title {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 24px 16px 16px;
}

.modal-message {
  text-align: center;
  font-size: 14px;
  color: #666;
  padding: 0 24px 24px;
  line-height: 1.6;
}

.modal-actions {
  display: flex;
  border-top: 1px solid #eee;
}

.modal-btn {
  flex: 1;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
  border: none;
  background: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.modal-btn-cancel {
  color: #666;
  border-right: 1px solid #eee;
}

.modal-btn-cancel:hover {
  background-color: #f5f5f5;
}

.modal-btn-confirm {
  color: #409eff;
}

.modal-btn-confirm:hover {
  background-color: #ecf5ff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
